  export const getAuthToken = () => {
    return localStorage.getItem("authToken");
  };
  export const setAuthToken = (token) => {
    localStorage.setItem("authToken", token);
  };
  export const getRefreshToken = () => {
    return localStorage.getItem("refreshAuthToken");
  };
  
  export const clearAuthToken = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshAuthToken");
  };
  
  export const isAuthenticated = () => {
    return getAuthToken() !== null;
  };